export default {
  copy: {
    id: 'merchant_integration_copy',
    defaultMessage: 'Copy',
  },
  confirmation: {
    id: 'merchant_integration_confirmation',
    defaultMessage: 'Your token is copied in your clipboard!',
  },
}
